import { handleFormSubmit } from "./form"

export default {
  handleFormSubmit,
  onSubmit: handleFormSubmit,
}
